const colors = {
  grey10: "#fcfcfc",
  grey70: "#616368",
  grey20: "#f7f7f7",
  grey80: "#3f4348",
  grey40: "#e0e0e0",
  grey90: "#27292c",
  grey30: "#f0f0f0",
  grey60: "#909296",
  grey50: "#bcbec0",
  primary: "#880f30",
  red: "#fe0000",
  blue: "#007aff",
  dailyPrayer: "#5dadde",
  sundayWorship: "#d20027",
  primary10: "#f9d1cc",
  primary20: "#f39e9c",
  primary30: "#db666f",
  primary40: "#b73d52",
  primary60: "#740a32",
  primary70: "#610731",
  primary80: "#4e042e",
  primary90: "#41022c",
  accentBlack: "#000000",
  accentWhite: "#ffffff",
  primaryA50: "#ad002f",
  defaultText: "#212529",
  transparent: "rgba(0,0,0,0)",
  buttonHighlight: "#DDDDDD",
};

export default colors;
